import { setSubscriptionDisposer } from './set-subscription-disposer';

export const actions = {
    setSubscriptionDisposer,
};
